import React from 'react';
import { Container, Row, Col, Navbar } from 'react-bootstrap';
import Menu from './Menu';
import resolvePublicAsset from '../utils/resolvePublicAsset';

function Header() {
  return (
    <Container fluid className='header'>
      <Row>
        <Col xs={12} md={12} lg={12}>
          <Container>
            <Row style={{ textAlign: 'center' }}>
              <Col xs={12} md={12} lg={12} style={{ padding: '20px' }}>
                <img
                  src={resolvePublicAsset('images/logo_acessopopular.png')}
                  width="200"
                  className="d-inline-block align-top"
                  alt="Logo do Instituto Acesso Popular"
                  style={{ textAlign: 'center' }}
                />
                <br />
                <span className='title' style={{ display: 'none' }}>Instituto Acesso Popular</span>
              </Col>
            </Row>
          </Container>
        </Col>
        <Col className='cor-primaria'>
          <Container>
            <Navbar expand="lg">
              <Menu />
            </Navbar>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}

export default Header;